export function canUseDOM() {
    return !!(typeof window !== "undefined" &&
        window.document &&
        window.document.createElement);
}
export const isBrowser = canUseDOM();
//# sourceMappingURL=utils.js.map